import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const GridText: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <BodyText className={`${className} ${styles.gridText}`} testId={testId} text={text} />
);

export default GridText;
